import * as React from "react";
import { FindDealerToolbarProps } from ".";
import Input from "../Fields/Input";

export default function Toolbar({
    isLocationDenied,
    zipcode,
    setZipcode,
    setLocationFromZipcode,
    setLocationFromCurrentPosition,
    ...props
}: FindDealerToolbarProps) {
    const timeoutCallback = React.useRef(null);

    const handleZipcodeChange = (e) => {
        setZipcode(e.target.value);

        if (!timeoutCallback) {
            clearTimeout(timeoutCallback.current);
        }
        timeoutCallback.current = setTimeout(() => {
            if (e.target.value) {
                setLocationFromZipcode(e.target.value);
                return;
            }
            setLocationFromCurrentPosition();
        }, 1000);
    };

    return (
        <div className="tmp-find-dealer__toolbar__container">
            <Input
                value={zipcode}
                onChange={handleZipcodeChange}
                input={{
                    placeholder: props?.settings?.zipcode_placeholder,
                }}
                {...(isLocationDenied
                    ? {}
                    : {
                          iconAfter: "fas fa-crosshairs",
                          iconAfterContainer: {
                              onClick: () => setLocationFromCurrentPosition(),
                          },
                      })}
                classes={{ input: "tmp-find-dealer__zipcode" }}
            />
        </div>
    );
}
